import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faPlay,
  faStar,
} from '@fortawesome/free-solid-svg-icons';
import AnalyticsTab from './AnalyticsTab';
import QuestionsTab from './QuestionsTab';
import PlayersTab from './PlayersTab';
import { mockGameDetail, mockGeoGameDetail } from './mockGameDetail';
import './GameDetail.css';
import { fetchGameDetailsStats } from '../../apiservices/axiosservice/gameservice';
import HostGamePlay from '../gamelobby/HostQuizGamePlay';
import HostGeoPlay from '../gamelobby/HostGeoPlay';

const tabs = ['Players'] as const;
type Tab = (typeof tabs)[number];

const GameDetail: React.FC = () => {
  const navigate = useNavigate();
  const { gameId } = useParams();
  const [activeTab, setActiveTab] = useState<Tab>('Analytics');
  const [showGamePlay, setShowGamePlay] = useState(false);
  //const data1 = gameId?.startsWith('geo') ? mockGeoGameDetail : mockGameDetail;
  const [data, setData] = useState<GameDetailDataStats>();
  const gameTypeMap = {
    geoplay: '📍 Geo Guess',
    quiz: '★ Smart Quiz',
  };

  useEffect(() => {
    const fetchGameDetail = async () => {
      try {
        const response = await fetchGameDetailsStats(gameId!);
        setData(response.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchGameDetail();
  }, []);

  const gamePlayStatus = (status: string | undefined) => {
    switch (status) {
      case 'LOBBY':
        return 'Not Started';
      case 'IN_PROGRESS':
        return 'Started';
      case 'FINISHED':
        return 'Finished';
      default:
        return status;
    }
  };

  const stats = [
    {
      icon: '🏆',
      value: data?.avgScore.toLocaleString(),
      label: 'Avg Score',
      color: 'var(--color-success)',
    },
  ];

  return (
    <div className="gd">
      {/* Breadcrumb */}
      <div className="gd__breadcrumb">
        <button
          className="gd__breadcrumb-back"
          onClick={() => navigate('/dashboard/games')}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <span
          className="gd__breadcrumb-link"
          onClick={() => navigate('/dashboard/games')}
        >
          My Games
        </span>
        <span className="gd__breadcrumb-sep">/</span>
        <span className="gd__breadcrumb-current">{data?.gameTitle}</span>
      </div>

      {/* Header banner */}
      <div className="gd__banner">
        <div className="gd__banner-icon">
          <FontAwesomeIcon icon={faStar} />
        </div>
        <div className="gd__banner-info">
          <div className="gd__banner-title-row">
            <h1 className="gd__banner-title">{data?.gameTitle}</h1>
            <span className="gd__banner-badge">
              {gameTypeMap[data?.gameType]}
            </span>
            <span className="gd__banner-status">
              {gamePlayStatus(data?.gameStatus)}
            </span>
          </div>
          <p className="gd__banner-meta">
            {data?.totalGame} plays · {data?.totalGame} rounds · Created{' '}
            {data?.createdAt}
          </p>
        </div>

        {data?.gameStatus &&
          ['LOBBY', 'IN_PROGRESS'].includes(data?.gameStatus) && (
            <button
              className="gd__banner-run"
              onClick={() =>
                navigate(`/dashboard/games/game/${gameId}/lobby`, {
                  state: {
                    gameType: data?.gameType,
                    gameStatus: data?.gameStatus,
                    gameTitle: data?.gameTitle,
                    totalGame: data?.totalGame,
                  },
                })
              }
            >
              <FontAwesomeIcon icon={faPlay} /> Run
            </button>
          )}
      </div>

      {/* Stats cards */}
      <div className="gd__stats">
        {stats.map((s) => (
          <div key={s.label} className="gd__stat-card">
            <span className="gd__stat-icon" style={{ color: s.color }}>
              {s.icon}
            </span>
            <div>
              <span className="gd__stat-value" style={{ color: s.color }}>
                {s.value}
              </span>
              <span className="gd__stat-label">{s.label}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div className="gd__tabs-card">
        <div className="gd__tabs">
          {tabs.map((t) => (
            <button
              key={t}
              className={`gd__tab ${activeTab === t ? 'gd__tab--active' : ''}`}
              onClick={() => setActiveTab(t)}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="gd__tab-content">
          {/* {activeTab === 'Analytics' && <AnalyticsTab data={data} />}
          {activeTab === 'Questions' && (
            <QuestionsTab questions={data.questions} />
          )} */}
          {activeTab === 'Players' && <PlayersTab players={data.players} />}
        </div>
      </div>
    </div>
  );
};

export default GameDetail;
